import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { itemGetApi, itemPostApi, itemPutApi, itemDeleteApi } from "../redux/actions/itemAction";

const Counter = () => {
	const itemState = useSelector(state => state.item);
	const dispatch = useDispatch();

	const [items, setItems] = useState([]);
	const [newItem, setNewItem] = useState({ name: "", price: "" });
	const [removeItem, setRemoveItem] = useState({ _id: "" });
	const [updateItem, setUpdateItem] = useState({
		_id: "",
		updItem: { name: "", price: "" },
	});

	useEffect(() => {
		dispatch(itemGetApi());
	}, []);

	useEffect(() => {
		setItems(itemState);
		console.log("Called!", itemState);
	}, [itemState]);

	return (
		<React.Fragment>
			<div>
				{items.map((item, index) => (
					<h3 key={index}>{`${item.name}| ${item.price}| ${item._id}|`}</h3>
				))}
			</div>
			<button onClick={() => dispatch(itemGetApi())}>GET (FETCH)</button>

			<form
				onSubmit={e => {
					e.preventDefault();
					setNewItem({ name: "", price: "" });
				}}
			>
				<input
					type="text"
					name="name"
					id="name"
					placeholder="name"
					required
					value={newItem.name}
					onChange={e => setNewItem({ ...newItem, [e.target.name]: e.target.value })}
				/>
				<input
					type="number"
					name="price"
					id="price"
					placeholder="price"
					required
					value={newItem.price}
					onChange={e => setNewItem({ ...newItem, [e.target.name]: e.target.value })}
				/>
				<input
					type="submit"
					value="POST (CREATE)"
					onClick={() => {
						dispatch(itemPostApi(newItem));
					}}
				/>
			</form>

			<form
				onSubmit={e => {
					e.preventDefault();
					setUpdateItem({ _id: "", updItem: { name: "", price: "" } });
					// dispatch(itemGetApi());
				}}
			>
				<input
					type="text"
					name="name"
					placeholder="name"
					required
					value={updateItem.updItem.name}
					onChange={e =>
						setUpdateItem({
							...updateItem,
							updItem: {
								...updateItem.updItem,
								[e.target.name]: e.target.value,
							},
						})
					}
				/>
				<input
					type="number"
					name="price"
					placeholder="price"
					required
					value={updateItem.updItem.price}
					onChange={e =>
						setUpdateItem({
							...updateItem,
							updItem: {
								...updateItem.updItem,
								[e.target.name]: e.target.value,
							},
						})
					}
				/>
				<input
					type="text"
					name="_id"
					placeholder="ID"
					required
					value={updateItem._id}
					onChange={e => setUpdateItem({ ...updateItem, [e.target.name]: e.target.value })}
				/>
				<input type="submit" value="PUT (UPDATE)" onClick={() => dispatch(itemPutApi(updateItem))} />
			</form>

			<form
				onSubmit={e => {
					e.preventDefault();
					setRemoveItem({ _id: "" });
				}}
			>
				<input
					type="text"
					name="_id"
					placeholder="ID"
					required
					value={removeItem._id}
					onChange={e => setRemoveItem({ [e.target.name]: e.target.value })}
				/>
				<input type="submit" value="DELETE (REMOVE)" onClick={() => dispatch(itemDeleteApi(removeItem))} />
			</form>
		</React.Fragment>
	);
};

export default Counter;
